// Mapping der feed_validation_summary-RPC auf die Readiness-Anzeige des Feed-Check-Reports.
// DB-rule_ids bleiben granular (gtin_invalid vs gtin_placeholder); die Anzeige fasst
// sie pro Handlungsempfehlung zusammen. Nur Eintraege mit count > 0 werden gerendert.

export type ReadinessKey = 'gtin' | 'unitPricing' | 'image' | 'brandPrefix' | 'titleLength' | 'normClaims' | 'thinSource';

export interface ReadinessEntry {
  key: ReadinessKey;
  count: number;
}

export interface ValidationSummaryRow {
  rule_id: string;
  product_count: number;
}

const RULE_TO_KEY: Record<string, ReadinessKey> = {
  gtin_invalid: 'gtin',
  gtin_placeholder: 'gtin',
  unit_pricing_check: 'unitPricing',
  image_too_small: 'image',
  brand_prefix_mismatch: 'brandPrefix',
  title_too_long: 'titleLength',
  norm_claim_ungrounded: 'normClaims',
  description_thin: 'thinSource',
};

export function readinessEntries(summary: ValidationSummaryRow[] | undefined): ReadinessEntry[] {
  if (!summary || summary.length === 0) return [];
  const counts = new Map<ReadinessKey, number>();
  for (const row of summary) {
    const key = RULE_TO_KEY[row.rule_id];
    if (!key) continue;
    counts.set(key, (counts.get(key) ?? 0) + Number(row.product_count));
  }
  return [...counts.entries()]
    .filter(([, count]) => count > 0)
    .map(([key, count]) => ({ key, count }))
    .sort((a, b) => b.count - a.count);
}
